import { render, staticRenderFns } from "./pcnewdetail.vue?vue&type=template&id=46369966"
import script from "./pcnewdetail.vue?vue&type=script&lang=js"
export * from "./pcnewdetail.vue?vue&type=script&lang=js"
import style0 from "./pcnewdetail.vue?vue&type=style&index=0&id=46369966&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports